import { TAGS_LIST } from "../constants";
import {
  MathProblem,
  OperatorModel,
  ProblemDifficultyLevel,
  ValidationStatusModel,
} from "../types";

export const getTagLables = (tags: string[]) => {
  return TAGS_LIST.filter((tag) => tags.includes(tag.value)).map(
    (tag) => tag.label
  );
};

export const saveToMyList = async (sdk: any, scenarioId: string) => {
  const settings = await sdk.getDataManager().getSettings();
  let mylist: String[] = [];
  if (settings && settings.mylist && settings.mylist.length > 0) {
    mylist = Object.assign([], settings.mylist);
  }
  mylist = [...mylist, scenarioId];
  mylist = mylist.filter((c, index) => {
    return mylist.indexOf(c) === index;
  });
  const res = await sdk.getDataManager().saveSettings({
    data: {
      mylist,
    },
  });
};

export const chunkArray = (arr: any[], size: number) => {
  const chunkedArray = [];
  for (let i = 0; i < arr.length; i++) {
    const last = chunkedArray[chunkedArray.length - 1];
    if (!last || last.length === size) {
      chunkedArray.push([arr[i]]);
    } else {
      last.push(arr[i]);
    }
  }
  return chunkedArray;
};

export const getFormattedProblem = (problemItem: MathProblem) => {
  return ``;
};

export const generateInitialProblems = (
  problemCount: number,
  operation: OperatorModel
) => {
  const problemKeys = Array.from(Array(problemCount), (_, index) => index + 1);

  return problemKeys.map((problemKey) => ({
    operand1: 0,
    operand2: 0,
    operator: operation,
    id: "1",
    difficulty: 1,
    level: "primary_1",
  }));
};

export const generateProblems = (
  level: string,
  operation: OperatorModel,
  problemsCount: number
): MathProblem[] => {
  const problemKeys = Array.from(Array(problemsCount), (_, index) => index + 1);

  return problemKeys.map((problemKey) => ({
    operand1: 1234.68,
    operand2: 34.567,
    operator: operation,
    id: "1",
    difficulty: 1,
    level: "primary_1",
  }));

  return problemKeys.map((problemKey) => ({
    operand1: Math.floor(1000 + Math.random() * 9000) / 100,
    operand2: Math.floor(1000 + Math.random() * 9000) / 100,
    operator: operation,
    id: "1",
    difficulty: 1,
    level: "primary_1",
  }));
};

export const convertAnswerString = (value: string) => {
  const stagingValue = value.replace(/^0+(\d)|(\d)0+$/gm, "$1$2");
  return Number(stagingValue.replace(",", "."));
};

export const getDecimalPart = (num: number) => {
  if (Number.isInteger(num)) {
    return 0;
  }

  const decimalStr = num.toString().split(".")[1];
  return Number(decimalStr);
};

export const addLeadingZeros = (num: number, totalLength: number) => {
  return String(num).padStart(totalLength, "0");
};

//length is not 0
export const getRandomIndex = (length: number) => {
  return Math.floor(Math.random() * length);
};

export const getProblem = async (
  sdk: any,
  tag: string,
  difficulty: number,
  operation: string
) => {
  try {
    const result = await sdk
      .getDataManager()
      .getMathProblems(tag, difficulty, operation);

    if (result && result.length > 0) {
      const randomIndex = getRandomIndex(result.length);
      const targetProblem: MathProblem = {
        id: result[randomIndex].id,
        operand1: result[randomIndex].data.terms.iv[0].term,
        operand2: result[randomIndex].data.terms.iv[1].term,
        operator: result[randomIndex].data.operationType.iv[0],
        difficulty: result[randomIndex].data.difficulty.iv,
        level: tag,
      };

      console.log("targetProblemhere", targetProblem);

      return targetProblem;
    } else {
      return null;
    }
  } catch (error) {
    console.log("errorhere", error);
    return null;
  }
};

export const getProblemDifficulty = (
  maxLevel: string,
  currentLevel: string,
  currentDifficulty: number,
  validationStatus: ValidationStatusModel,
  prevValidationStatus?: ValidationStatusModel
): ProblemDifficultyLevel => {
  const maxLevelIndex = TAGS_LIST.findIndex(
    (level) => level.value === maxLevel
  );
  if (validationStatus === "success") {
    const progressAmout = prevValidationStatus === "success" ? 2 : 1;
    const currentLevelIndex = TAGS_LIST.findIndex(
      (level) => level.value === currentLevel
    );

    if (currentDifficulty + progressAmout <= 6) {
      return {
        difficulty: currentDifficulty + progressAmout,
        level: currentLevel,
      };
    }
    // reaches to max difficulty 6
    else {
      if (currentLevelIndex + 1 <= maxLevelIndex) {
        return {
          difficulty: (currentDifficulty + progressAmout) % 6,
          level: TAGS_LIST[currentLevelIndex + 1].value,
        };
      }
      // reaches to max level
      else {
        return {
          difficulty: 6,
          level: maxLevel,
        };
      }
    }
  } else {
    const progressAmout = prevValidationStatus === "fail" ? 2 : 1;

    const currentLevelIndex = TAGS_LIST.findIndex(
      (level) => level.value === currentLevel
    );

    if (currentDifficulty - progressAmout > 0) {
      return {
        difficulty: currentDifficulty - progressAmout,
        level: currentLevel,
      };
    }
    // reaches to min difficulty 0
    else {
      if (currentLevelIndex > 0) {
        return {
          difficulty: 3,
          level: TAGS_LIST[currentLevelIndex - 1].value,
        };
      }
      // reaches to min level i.e primary_1
      else {
        return {
          difficulty: 1,
          level: TAGS_LIST[0].value,
        };
      }
    }
  }
};

export const intlNumberComma = (locale : string) => locale === "fr" ? "," : "."

export const intlNumber = (number: number, locale : string) => {
  if (locale === "fr") {
    if (number >= 10000) return new Intl.NumberFormat('fr-FR').format(number)
    else return number.toString().replaceAll("." ,",")
  } else {
    return new Intl.NumberFormat('en-EN').format(number).replaceAll(",", " ")
  }
}